<template>
  <BContainer
    class="mb-4"
  >
    <div class="d-flex justify-content-end">
      <BBreadcrumb
        v-if="$route.meta.breadcrumb"
        :items="$route.meta.breadcrumb || []"
      />
    </div>

    <BTabs
      v-model="currentTabIndex"
      class="mt-3"
      nav-class="scrollable-x-tabs no-scrollbar nav-month-tabs gap-x-1"
    >
      <template #tabs-start>
        <div class="d-flex justify-content-between align-items-center gap-2">
          <BButton
            size="sm"
            variant="primary"
            @click.prevent="createMonth"
          >
            <i class="fas fa-plus pr-0" /> Month
          </BButton>
        </div>
      </template>
      <BTab
        v-for="(month, index) in months"
        :key="index"
        title-link-class="p-0"
        class="py-3"
        lazy
      >
        <template #title>
          <div class="d-flex justify-content-between align-items-center gap-2 min-w-75px">
            <div class="px-2">
              {{ MOMENT(month).format('MMM YYYY') }}
            </div>
            <BButton
              size="sm"
              variant="link"
              class="text-danger"
              :disabled="months.length <= 1"
              @click.prevent="removeMonth(month)"
            >
              <i class="fas fa-times pr-0" />
            </BButton>
          </div>
        </template>
        <Tasks
          :month="month"
          :more-details="1"
        >
          <template #header-actions="gridTasks">
            <BCol
              cols="12"
            >
              <BFormGroup
                label="Search"
                label-for="filterSearch"
                label-class="font-weight-bolder"
                class="mb-2"
              >
                <BFormInput
                  id="filterSearch"
                  v-model="gridTasks.filter.search"
                  placeholder="search here"
                  autocomplete="off"
                  debounce="1000"
                  type="text"
                />
              </BFormGroup>
            </BCol>
          </template>
        </Tasks>
      </BTab>
    </BTabs>

    <BModal
      ref="modalMonth"
      scrollable
      no-close-on-esc
      no-enforce-focus
      no-close-on-backdrop
      aria-hidden="false"
      role="dialog"
      title="Add Comparison Month"
    >
      <ValidationObserver
        ref="formMonth"
      >
        <form
          role="form"
          novalidate
          @submit.prevent
        >
          <BRow>
            <BCol
              cols="12"
            >
              <ValidationProvider
                v-slot="{ errors }"
                vid="month"
                name="month"
                :rules="{
                  required: true,
                  excluded: months
                }"
              >
                <BFormGroup
                  label="Month"
                  label-for="fMonth"
                  label-class="font-weight-bolder"
                  class="mb-2"
                >
                  <BFormInput
                    id="fMonth"
                    v-model="formMonth.month"
                    type="month"
                    :state="errors.length > 0 ? false : null"
                  />
                  <div
                    v-if="(errors.length > 0)"
                    class="invalid-feedback"
                    v-text="errors[0]"
                  />
                </BFormGroup>
              </ValidationProvider>
            </BCol>
          </BRow>
        </form>
      </ValidationObserver>
      <template #modal-footer="{ cancel }">
        <BButton
          variant="primary"
          @click.prevent="validateMonth"
        >
          Add Month
        </BButton>
        <BButton

          variant="outline-dark"
          @click.prevent="discardBtnEvent => preventAriaHidden(discardBtnEvent, cancel)"
        >
          Discard
        </BButton>
      </template>
    </BModal>
  </BContainer>
</template>
<script>
import MOMENT from 'moment'

import Tasks from '@/views/fso/tasks/Tasks.vue'

import MxMisc from '@/mixins/misc'

export default {
  name: 'FSOTasksMonthComparisons',

  midddleware: [
    'auth',
    'fso'
  ],

  metaInfo: () => ({
    title: 'Tasks - Month Comparisons'
  }),

  components: {
    Tasks
  },

  mixins: [
    MxMisc
  ],

  data () {
    return {
      MOMENT,
      currentTabIndex: 0,
      formMonth: {
        month: ''
      },
      months: [
        // MOMENT().subtract(1, 'month').format('YYYY-MM'),
        MOMENT().format('YYYY-MM')
      ]
    }
  },
  methods: {
    createMonth () {
      if (this.months.length >= 5) {
        return this.swalInvalid('<h6>You can only compare up to 5 months.</h6>')
      }

      this.formMonth.month = ''
      this.$refs.modalMonth.show()
    },

    validateMonth () {
      this.$refs.formMonth.validate().then(
        validMonth => {
          if (!validMonth) {
            return this.swalInvalid()
          }
          this.months.push(this.formMonth.month)
          this.$refs.modalMonth.hide()
        }
      )
    },

    removeMonth (selectedMonth) {
      this.months = this.months.filter(
        month => !MOMENT(month).isSame(MOMENT(selectedMonth), 'month')
      )
    }
  }
}
</script>
